import { Typography } from 'antd'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

export const FilterSection = styled.div`
  margin-bottom: 1.5rem;
`

export const FilterTitle = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    color: ${CantileverTheme.colors.slate['400']};
  }
`

export const CountBadge = styled(Typography.Text)`
  color: ${CantileverTheme.colors.slate['500']};
  font-size: 0.75rem;
  white-space: nowrap;
`

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const CheckboxWithCount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const LabelCell = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
`
